class Video {
    constructor() {
        // global class identifier
        this.class = {
            videoWrapper: '.video_wrapper',
            carousel: '.carousel',
            videoText: '.js__video-text',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * Two Click solution for YouTube Video - Background-Image
     */
    videoPlaceholder() {
        const videoWrapper = document.querySelectorAll(this.class.videoWrapper);
        if (videoWrapper.length > 0) {
            videoWrapper.forEach((wrapper) => {
                wrapper.querySelector('button[type="button"]').addEventListener('click', (e) => {
                    const trigger = e.currentTarget.parentElement;
                    trigger.closest('.video-module').querySelector(this.class.videoText).classList.add('d-none');
                    trigger.classList.add('d-none');
                    trigger.nextElementSibling.classList.add('d-block');
                    trigger.nextElementSibling.querySelector('iframe').setAttribute('src', `https://www.youtube-nocookie.com/embed/${trigger.dataset.source}?rel=0&controls=0&showinfo=0&autoplay=1`);
                });
            });
        }
    }

    /**
     * Pause iframe videos on carousel slide
     */
    iframeVideoStopOnSlide() {
        const carousel = document.querySelectorAll(this.class.carousel);

        if (carousel.length > 0) {
            carousel.forEach((carouselItem) => {
                carouselItem.addEventListener('slide.bs.carousel', () => {
                    document.querySelectorAll('.carousel-video').forEach((e) => {
                        if (e.currentTarget.closest('.carousel-item').classList.contains('active')) {
                            e.currentTarget.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                        }
                    });
                });
            });
        }
    }

    init() {
        this.videoPlaceholder();
        this.iframeVideoStopOnSlide();
    }
}

export default new Video();
